import React from "react";
import { Backdrop, Box, Button, CircularProgress } from "@mui/material";

import SessionSequenceHeader from "./SessionSequenceHeader";
import SessionSequenceTable from "./SessionSequenceTable";
import SessionSequenceDialogs from "./SessionSequenceDialogs";
import { step4Styles } from "./SessionSequenceStep.styles";
import useSessionSequenceStep from "./useSessionSequenceStep";

const SessionSequenceStep = ({ onNext, onBack, data, setData }) => {
  const sequence = useSessionSequenceStep({ data, onBack, onNext, setData });

  if (sequence.loadingData) {
    return (
      <Box className="step4-root" sx={{ p: 4, display: "flex", justifyContent: "center" }}>
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <Box className={`step4-root ${sequence.loadingGeneral ? "loading-table" : ""}`} sx={step4Styles}>
      <Backdrop open={sequence.loadingContinue} sx={{ zIndex: 2000 }} className="step4-backdrop">
        <CircularProgress color="inherit" />
      </Backdrop>

      <SessionSequenceHeader
        firstRow={sequence.data[0]}
        hayCambios={sequence.hayCambios}
        loadingGeneral={sequence.loadingGeneral}
        onOpenRegenerateAll={() => sequence.setOpenConfirmRegenerarTodo(true)}
      />

      <SessionSequenceTable
        data={sequence.data}
        loadingGeneral={sequence.loadingGeneral}
        regenerandoId={sequence.regenerandoId}
        competenciasDisponibles={sequence.competenciasDisponibles}
        loadingCompetencias={sequence.loadingCompetencias}
        onMoveRow={sequence.moverFila}
        onCompetenciaChange={sequence.cambiarCompetencia}
        onOpenDescription={sequence.abrirDetalleDescripcion}
        onConfirmRegenerateRow={(row) => sequence.setSesionARegenerar(row)}
        onEditRow={sequence.abrirEditar}
      />

      <Box className="step4-footer" sx={{ mt: 3, display: "flex", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}>
        <Box
          title={
            sequence.loadingGeneral
              ? "Espera a que termine la regeneración"
              : sequence.regenerandoId !== null
                ? "Hay una sesión en proceso"
                : ""
          }
        >
          <Button
            variant="outlined"
            onClick={sequence.handleBackClick}
            disabled={sequence.loadingGeneral || sequence.regenerandoId !== null}
            className="step4-btn step4-btn-back"
          >
            Atrás
          </Button>
        </Box>

        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", flexDirection: "row", alignItems: "inherit" }}>
          <Button
            variant="contained"
            onClick={sequence.handleGuardar}
            disabled={!sequence.hayCambios || sequence.loadingGuardar}
            className="step4-btn step4-btn-save"
          >
            {sequence.loadingGuardar ? <CircularProgress size={20} color="inherit" /> : "Guardar"}
          </Button>

          {sequence.temasGenerados && (
            <Box
              title={
                sequence.loadingGeneral
                  ? "Espera a que termine la regeneración"
                  : sequence.regenerandoId !== null
                    ? "Hay una sesión en proceso"
                    : sequence.hayCambios
                      ? "Guarda los cambios antes de continuar"
                      : ""
              }
            >
              <Button
                variant="contained"
                onClick={sequence.handleContinuar}
                disabled={sequence.hayCambios || sequence.loadingGeneral || sequence.regenerandoId !== null}
                className="step4-btn step4-btn-continue"
              >
                Continuar
              </Button>
            </Box>
          )}
        </Box>
      </Box>

      <SessionSequenceDialogs
        {...sequence}
        onSaveEdit={sequence.guardarEdicion}
        onRegenerateAll={sequence.onConfirmRegenerateAll}
      />
    </Box>
  );
};

export default SessionSequenceStep;
